/* src/app/components/payroll/authorizations/authorization-documents/authorization-documents.component.css */
/*# sourceMappingURL=authorization-documents.component-3GDRV5AL.css.map */
